import { z } from 'zod';
import { positiveMoneySchema } from '../money.js';
import { text, uuidSchema } from './common.js';
/**
 * Tenant-initiated ACH Direct Debit — enrollment and manual payment submission.
 *
 * Deliberately thin. The heavy lifting (SetupIntent params, PaymentIntent
 * confirmation, webhook dispatch) lives in `modules/ledger/stripe-service.ts`
 * on the API side, where the Stripe SDK is; this file only validates what
 * crosses the wire.
 */
export const confirmEnrollmentSchema = z.object({
    setupIntentId: text(255),
});
/**
 * Not capped at the lease's current open balance — allocation happens later,
 * at settlement (`applySettlement`), and a partial or advance payment is
 * legitimate (mirrors `recordManualPayment`/`allocatePayment`, which already
 * allow partial, incremental allocation). The $50,000 ceiling exists only to
 * catch a fat-fingered entry, not to model a real limit.
 */
export const submitPaymentSchema = z.object({
    leaseId: uuidSchema,
    amount: positiveMoneySchema.refine((v) => v.lessThanOrEqualTo('50000.00'), {
        message: 'Enter an amount of $50,000 or less. Contact the management office for anything larger.',
    }),
});
//# sourceMappingURL=stripe.js.map